//cropped room
import bathroomPicCropped from './gateImages/cropped/Bathroom-crop.jpg';
import bedroomPicCropped from './gateImages/cropped/Bedroom-crop.jpg';
import diningPicCropped from './gateImages/cropped/Dining-crop.jpg';
import hallwayPicCropped from './gateImages/cropped/Hallway-crop.jpg';
import kitchenPicCropped from './gateImages/cropped/Kitchen-crop.jpg';
import laundryPicCropped from './gateImages/cropped/Laundry-crop.jpg';
import livingPicCropped from './gateImages/cropped/Living-crop.jpg';
import nurseryPicCropped from './gateImages/cropped/Nursery-crop.jpg';
import officePicCropped from './gateImages/cropped/Office-crop.jpg';
import ourdoorPicCropped from './gateImages/cropped/Outdoor-crop.jpg';

//cropped product
import artPicCropped from './gateImages/cropped/Art-crop.jpg';
import bedsPicCropped from './gateImages/cropped/Bed-crop.jpg';
import chairsPicCropped from './gateImages/cropped/Chair-crop.jpg';
import interiorsPicCropped from './gateImages/cropped/Interiors-jug-crop.jpg';
import lightingPicCropped from './gateImages/cropped/Interiors-light-crop.jpg';
import outdoorPicCropped from './gateImages/cropped/Outdoor-furniture-crop.jpg';
import sofaPicCropped from './gateImages/cropped/Couch-crop.jpg';
import storagePicCropped from './gateImages/cropped/Storage-crop.jpg';
import tablePicCropped from './gateImages/cropped/Tables-crop.jpg';
import tablewarePicCropped from './gateImages/cropped/Tableware-crop.jpg';

export const getCorrespondingCroppedImage = (key, interiorsDefault) => {
  if (key === 'bathroom') {
    return { image: bathroomPicCropped, isDarkBackground: false };
  }

  if (key === 'bedroom') {
    return { image: bedroomPicCropped, isDarkBackground: false };
  }

  if (key === 'dining') {
    return { image: diningPicCropped, isDarkBackground: false }; //in received images is the same for both kitchen and dining
  }

  if (key === 'hallway') {
    return { image: hallwayPicCropped, isDarkBackground: false };
  }

  if (key === 'kitchen') {
    return { image: kitchenPicCropped, isDarkBackground: false };
  }

  if (key === 'laundry') {
    return { image: laundryPicCropped, isDarkBackground: true };
  }

  if (key === 'living') {
    return { image: livingPicCropped, isDarkBackground: false };
  }

  if (key === 'nursery') {
    return { image: nurseryPicCropped, isDarkBackground: false };
  }

  if (key === 'office') {
    return { image: officePicCropped, isDarkBackground: false };
  }

  if (key === 'outdoor') {
    return { image: ourdoorPicCropped, isDarkBackground: false };
  }


  if (key === 'Art') {
    return { image: artPicCropped, isDarkBackground: false };
  }

  if (key === 'Beds') {
    return { image: bedsPicCropped, isDarkBackground: false };
  }

  if (key === 'Chairs') {
    return { image: chairsPicCropped, isDarkBackground: false };
  }

  if (key === 'Interiors') {
    return { image: interiorsPicCropped, isDarkBackground: true };
  }

  if (key === 'Lighting') {
    return { image: lightingPicCropped, isDarkBackground: true };
  }

  if (key === 'Outdoor') {
    return { image: outdoorPicCropped, isDarkBackground: false };
  }

  if (key === 'Couches') {
    return { image: sofaPicCropped, isDarkBackground: false };
  }

  if (key === 'Storage') {
    return { image: storagePicCropped, isDarkBackground: false };
  }

  if (key === 'Tables') {
    return { image: tablePicCropped, isDarkBackground: false };
  }

  if (key === 'Tableware') {
    return { image: tablewarePicCropped, isDarkBackground: false };
  }

  if (interiorsDefault) {
    return { image: interiorsPicCropped, isDarkBackground: false };
  }

  return { image: couchTexture, isDarkBackground: true };
};
